export const REPORT_TEAM_TEXT_COPY = {
  DEFAULT: 0,
  CHANNEL_TOP: 1,
  TEAM: 2,
  ACTIVITY: 3,
  SCREEN_SHARE: 4,
};

// 首页Header点击需要上报的名字
export const REPORT_HOME_CLICK_ITEMS = ['MiniprogramPlatform', 'VoicePlatform'];

// 小黑盒举报 report和comment
export const HB_REPORT_API_TYPES = ['report', 'comment'];

// 群聊举报相关接口
export const GROUP_CHAT_REPORT_API_TYPES = ['chat_group', 'chat_group_message'];